// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-page {
  background: #f6f4f1;
  color: #2e2e2e;
  font-family: "Gilroy", 'Poppins', sans-serif;
}

.contact-container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 32px;
}

.contact-hero {
  position: relative;
  background: #2e2e2e;
  color: #fff;
  text-align: center;
  padding: 100px 0 150px;
  overflow: hidden;
}
.contact-hero-glow {
  position: absolute;
  inset: -20% -10% auto -10%;
  height: 120%;
  background:
    radial-gradient(circle at 25% 30%, rgba(255, 214, 170, 0.22), transparent 45%),
    radial-gradient(circle at 80% 60%, rgba(170, 200, 255, 0.18), transparent 50%);
  animation: contactGlow 14s ease-in-out infinite alternate;
}
@keyframes contactGlow {
  from { transform: translate3d(-2%, 0, 0) scale(1); }
  to { transform: translate3d(2%, 3%, 0) scale(1.08); }
}
.contact-hero .contact-container { position: relative; }
.contact-eyebrow {
  display: inline-block;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.65);
  margin-bottom: 20px;
}
.contact-hero h1 {
  font-size: 27px;
  line-height: 1.1;
  font-weight: 800;
  letter-spacing: -0.03em;
  max-width: 800px;
  margin: 0 auto 22px;
}
.contact-hero p {
  font-size: 14px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.8);
  max-width: 620px;
  margin: 0 auto;
}

.contact-body {
  padding: 0 0 110px;
}
.contact-grid {
  display: grid;
  grid-template-columns: 5fr 7fr;
  gap: 32px;
  margin-top: -80px;
  position: relative;
  align-items: start;
}

/* Channel cards */
.contact-channels {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.contact-card {
  display: flex;
  align-items: center;
  gap: 18px;
  background: #fff;
  border-radius: 5px;
  padding: 22px 24px;
  color: inherit;
  text-decoration: none;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.07);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}
.contact-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.12);
}
.contact-card-icon {
  flex: 0 0 52px;
  height: 52px;
  border-radius: 50%;
  background: #2e2e2e;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
}
.contact-card-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1;
}
.contact-card-text strong { font-size: 13px; letter-spacing: 0.1em; text-transform: uppercase; color: #909090; }
.contact-card-value { font-size: 18px; font-weight: 700; margin: 2px 0; overflow-wrap: anywhere; }
.contact-card-text small { font-size: 13px; color: #909090; }
.contact-card-arrow { font-size: 20px; color: #909090; transition: transform 0.25s ease; }
.contact-card:hover .contact-card-arrow { transform: translateX(4px); color: #2e2e2e; }

/* Form */
.contact-form {
  background: #fff;
  border-radius: 5px;
  padding: 40px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.09);
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.contact-form h2 { margin: 0; font-size: 26px; font-weight: 800; letter-spacing: -0.01em; }
.contact-form label > span {
  display: block;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
}
.contact-form input[type='text'],
.contact-form input[type='email'],
.contact-form input[type='tel'],
.contact-form textarea {
  width: 100%;
  box-sizing: border-box;
  font: inherit;
  font-size: 16px;
  padding: 14px 16px;
  border: 1.5px solid #e2e2e2;
  border-radius: 5px;
  background: #fafafa;
  color: #2e2e2e;
  transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;
}
.contact-form textarea { resize: vertical; min-height: 130px; }
.contact-form input:focus,
.contact-form textarea:focus {
  outline: none;
  border-color: #2e2e2e;
  background: #fff;
  box-shadow: 0 0 0 4px rgba(46, 46, 46, 0.08);
}
.contact-row { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }

.contact-types {
  border: 0;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.contact-types legend { font-size: 14px; font-weight: 600; margin-bottom: 10px; padding: 0; }
.contact-types label {
  flex: 1 1;
  min-width: 110px;
  text-align: center;
  padding: 12px 14px;
  border: 1.5px solid #e2e2e2;
  border-radius: 5px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.contact-types label:hover { border-color: #2e2e2e; }
.contact-types label.selected { background: #2e2e2e; border-color: #2e2e2e; color: #fff; }
.contact-types input { position: absolute; opacity: 0; pointer-events: none; }

.contact-hp { position: absolute !important; left: -9999px; width: 1px; height: 1px; opacity: 0; }

.contact-submit {
  align-self: flex-start;
  font: inherit;
  font-size: 17px;
  font-weight: 600;
  color: #fff;
  background: #2e2e2e;
  border: 0;
  border-radius: 5px;
  padding: 16px 38px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s, opacity 0.2s;
}
.contact-submit:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2); }
.contact-submit:disabled { opacity: 0.6; cursor: wait; }

.contact-msg { margin: 0; padding: 14px 18px; border-radius: 5px; font-size: 15px; line-height: 1.5; }
.contact-msg.ok { background: #e8f6ee; color: #1f6b42; }
.contact-msg.err { background: #fdecec; color: #a12a2a; }

@media (max-width: 900px) {
  .contact-grid { grid-template-columns: 1fr; margin-top: -60px; }
  .contact-hero { padding: 80px 0 110px; }
}
@media (max-width: 560px) {
  .contact-container { padding: 0 16px; }
  .contact-form { padding: 28px 20px; }
  .contact-row { grid-template-columns: 1fr; }
  .contact-submit { align-self: stretch; }
  .contact-body { padding-bottom: 70px; }
}
@media (prefers-reduced-motion: reduce) {
  .contact-hero-glow { animation: none; }
}

/* ---- Social cards: animations ---- */
.contact-card {
  position: relative;
  overflow: hidden;
  isolation: isolate;
  animation: cardIn 0.7s cubic-bezier(0.2, 0.8, 0.2, 1) backwards;
  animation-delay: calc(var(--i, 0) * 140ms + 150ms);
  transition: transform 0.35s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.35s ease, color 0.3s ease;
}
@keyframes cardIn {
  from { opacity: 0; transform: translateX(-40px); }
  to { opacity: 1; transform: none; }
}

/* Brand-colour fill that wipes in from the left on hover */
.contact-card::before {
  content: '';
  position: absolute;
  inset: 0;
  z-index: -1;
  background: var(--brand);
  transform: translateX(-101%);
  transition: transform 0.45s cubic-bezier(0.2, 0.8, 0.2, 1);
}
/* Diagonal light sweep */
.contact-card::after {
  content: '';
  position: absolute;
  top: 0;
  left: -60%;
  width: 40%;
  height: 100%;
  background: linear-gradient(100deg, transparent, rgba(255, 255, 255, 0.45), transparent);
  transform: skewX(-20deg);
  z-index: -1;
  pointer-events: none;
}
.contact-card:hover::before { transform: none; }
.contact-card:hover::after { animation: cardShine 0.9s ease; }
@keyframes cardShine {
  from { left: -60%; }
  to { left: 130%; }
}
.contact-card:hover { transform: translateY(-4px) scale(1.015); }
.contact-card:hover .contact-card-text strong,
.contact-card:hover .contact-card-text small,
.contact-card:hover .contact-card-value,
.contact-card:hover .contact-card-arrow { color: #fff; }

.contact-card--whatsapp { --brand: #25d366; }
.contact-card--instagram { --brand: linear-gradient(45deg, #f09433, #dc2743 50%, #bc1888); }
.contact-card--email { --brand: #2e2e2e; }

/* Icon: idle pulse ring + hover wiggle */
.contact-card-icon {
  position: relative;
  transition: background 0.3s ease, color 0.3s ease, transform 0.4s ease;
}
.contact-card-icon::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 2px solid var(--ring, #2e2e2e);
  opacity: 0;
  animation: iconPulse 2.6s ease-out infinite;
  animation-delay: calc(var(--i, 0) * 500ms);
}
.contact-card--whatsapp .contact-card-icon { --ring: #25d366; }
.contact-card--instagram .contact-card-icon { --ring: #dc2743; }
@keyframes iconPulse {
  0% { transform: scale(1); opacity: 0.6; }
  70%, 100% { transform: scale(1.7); opacity: 0; }
}
.contact-card:hover .contact-card-icon {
  background: #fff;
  color: #2e2e2e;
  animation: iconWiggle 0.7s ease;
}
.contact-card--whatsapp:hover .contact-card-icon { color: #25d366; }
.contact-card--instagram:hover .contact-card-icon { color: #dc2743; }
@keyframes iconWiggle {
  0% { transform: rotate(0) scale(1); }
  25% { transform: rotate(-16deg) scale(1.18); }
  50% { transform: rotate(12deg) scale(1.18); }
  75% { transform: rotate(-6deg) scale(1.1); }
  100% { transform: rotate(0) scale(1.1); }
}

.contact-card-arrow { transition: transform 0.3s ease, color 0.3s ease; }
.contact-card:hover .contact-card-arrow { transform: translateX(8px); }

.contact-card:active { transform: scale(0.98); }

/* Form slides in too */
.contact-form {
  animation: formIn 0.8s cubic-bezier(0.2, 0.8, 0.2, 1) 0.2s backwards;
}
@keyframes formIn {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: none; }
}

@media (prefers-reduced-motion: reduce) {
  .contact-card, .contact-form { opacity: 1; animation: none; }
  .contact-card-icon::after { animation: none; }
  .contact-card:hover .contact-card-icon { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Contact.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;EACZ;;kFAEgF;EAChF,yDAAyD;AAC3D;AACA;EACE,OAAO,0CAA0C,EAAE;EACnD,KAAK,6CAA6C,EAAE;AACtD;AACA,mCAAmC,kBAAkB,EAAE;AACvD;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,0CAA0C;EAC1C,uDAAuD;AACzD;AACA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;AACA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAO;AACT;AACA,4BAA4B,eAAe,EAAE,qBAAqB,EAAE,yBAAyB,EAAE,cAAc,EAAE;AAC/G,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,aAAa,EAAE,uBAAuB,EAAE;AACjG,2BAA2B,eAAe,EAAE,cAAc,EAAE;AAC5D,sBAAsB,eAAe,EAAE,cAAc,EAAE,gCAAgC,EAAE;AACzF,0CAA0C,0BAA0B,EAAE,cAAc,EAAE;;AAEtF,SAAS;AACT;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA,mBAAmB,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAC1F;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;;;EAIE,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,+DAA+D;AACjE;AACA,yBAAyB,gBAAgB,EAAE,iBAAiB,EAAE;AAC9D;;EAEE,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,4CAA4C;AAC9C;AACA,eAAe,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE;;AAEzE;EACE,SAAS;EACT,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,SAAS;AACX;AACA,wBAAwB,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,UAAU,EAAE;AAC5F;EACE,SAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA,6BAA6B,qBAAqB,EAAE;AACpD,gCAAgC,mBAAmB,EAAE,qBAAqB,EAAE,WAAW,EAAE;AACzF,uBAAuB,kBAAkB,EAAE,UAAU,EAAE,oBAAoB,EAAE;;AAE7E,cAAc,6BAA6B,EAAE,aAAa,EAAE,UAAU,EAAE,WAAW,EAAE,UAAU,EAAE;;AAEjG;EACE,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yDAAyD;AAC3D;AACA,uCAAuC,2BAA2B,EAAE,0CAA0C,EAAE;AAChH,2BAA2B,YAAY,EAAE,YAAY,EAAE;;AAEvD,eAAe,SAAS,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACrG,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;;AAExD;EACE,gBAAgB,0BAA0B,EAAE,iBAAiB,EAAE;EAC/D,gBAAgB,qBAAqB,EAAE;AACzC;AACA;EACE,qBAAqB,eAAe,EAAE;EACtC,gBAAgB,kBAAkB,EAAE;EACpC,eAAe,0BAA0B,EAAE;EAC3C,kBAAkB,mBAAmB,EAAE;EACvC,gBAAgB,oBAAoB,EAAE;AACxC;AACA;EACE,qBAAqB,eAAe,EAAE;AACxC;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,+DAA+D;EAC/D,kDAAkD;EAClD,kGAAkG;AACpG;AACA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA,2DAA2D;AAC3D;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,wBAAwB;EACxB,4BAA4B;EAC5B,0DAA0D;AAC5D;AACA,yBAAyB;AACzB;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,UAAU;EACV,YAAY;EACZ,wFAAwF;EACxF,wBAAwB;EACxB,WAAW;EACX,oBAAoB;AACtB;AACA,8BAA8B,eAAe,EAAE;AAC/C,6BAA6B,8BAA8B,EAAE;AAC7D;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;AACA,sBAAsB,wCAAwC,EAAE;AAChE;;;0CAG0C,WAAW,EAAE;;AAEvD,0BAA0B,gBAAgB,EAAE;AAC5C,2BAA2B,8DAA8D,EAAE;AAC3F,uBAAuB,gBAAgB,EAAE;;AAEzC,yCAAyC;AACzC;EACE,kBAAkB;EAClB,sEAAsE;AACxE;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,sCAAsC;EACtC,UAAU;EACV,2CAA2C;EAC3C,0CAA0C;AAC5C;AACA,6CAA6C,eAAe,EAAE;AAC9D,8CAA8C,eAAe,EAAE;AAC/D;EACE,KAAK,mBAAmB,EAAE,YAAY,EAAE;EACxC,YAAY,qBAAqB,EAAE,UAAU,EAAE;AACjD;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,+BAA+B;AACjC;AACA,mDAAmD,cAAc,EAAE;AACnE,oDAAoD,cAAc,EAAE;AACpE;EACE,KAAK,6BAA6B,EAAE;EACpC,MAAM,qCAAqC,EAAE;EAC7C,MAAM,oCAAoC,EAAE;EAC5C,MAAM,mCAAmC,EAAE;EAC3C,OAAO,+BAA+B,EAAE;AAC1C;;AAEA,sBAAsB,gDAAgD,EAAE;AACxE,0CAA0C,0BAA0B,EAAE;;AAEtE,uBAAuB,sBAAsB,EAAE;;AAE/C,uBAAuB;AACvB;EACE,oEAAoE;AACtE;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA;EACE,+BAA+B,UAAU,EAAE,eAAe,EAAE;EAC5D,4BAA4B,eAAe,EAAE;EAC7C,yCAAyC,eAAe,EAAE;AAC5D","sourcesContent":[".contact-page {\n  background: #f6f4f1;\n  color: #2e2e2e;\n  font-family: \"Gilroy\", 'Poppins', sans-serif;\n}\n\n.contact-container {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 0 32px;\n}\n\n.contact-hero {\n  position: relative;\n  background: #2e2e2e;\n  color: #fff;\n  text-align: center;\n  padding: 100px 0 150px;\n  overflow: hidden;\n}\n.contact-hero-glow {\n  position: absolute;\n  inset: -20% -10% auto -10%;\n  height: 120%;\n  background:\n    radial-gradient(circle at 25% 30%, rgba(255, 214, 170, 0.22), transparent 45%),\n    radial-gradient(circle at 80% 60%, rgba(170, 200, 255, 0.18), transparent 50%);\n  animation: contactGlow 14s ease-in-out infinite alternate;\n}\n@keyframes contactGlow {\n  from { transform: translate3d(-2%, 0, 0) scale(1); }\n  to { transform: translate3d(2%, 3%, 0) scale(1.08); }\n}\n.contact-hero .contact-container { position: relative; }\n.contact-eyebrow {\n  display: inline-block;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.65);\n  margin-bottom: 20px;\n}\n.contact-hero h1 {\n  font-size: 27px;\n  line-height: 1.1;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  max-width: 800px;\n  margin: 0 auto 22px;\n}\n.contact-hero p {\n  font-size: 14px;\n  line-height: 1.7;\n  color: rgba(255, 255, 255, 0.8);\n  max-width: 620px;\n  margin: 0 auto;\n}\n\n.contact-body {\n  padding: 0 0 110px;\n}\n.contact-grid {\n  display: grid;\n  grid-template-columns: 5fr 7fr;\n  gap: 32px;\n  margin-top: -80px;\n  position: relative;\n  align-items: start;\n}\n\n/* Channel cards */\n.contact-channels {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.contact-card {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  background: #fff;\n  border-radius: 5px;\n  padding: 22px 24px;\n  color: inherit;\n  text-decoration: none;\n  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.07);\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n}\n.contact-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.12);\n}\n.contact-card-icon {\n  flex: 0 0 52px;\n  height: 52px;\n  border-radius: 50%;\n  background: #2e2e2e;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n}\n.contact-card-text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  flex: 1;\n}\n.contact-card-text strong { font-size: 13px; letter-spacing: 0.1em; text-transform: uppercase; color: #909090; }\n.contact-card-value { font-size: 18px; font-weight: 700; margin: 2px 0; overflow-wrap: anywhere; }\n.contact-card-text small { font-size: 13px; color: #909090; }\n.contact-card-arrow { font-size: 20px; color: #909090; transition: transform 0.25s ease; }\n.contact-card:hover .contact-card-arrow { transform: translateX(4px); color: #2e2e2e; }\n\n/* Form */\n.contact-form {\n  background: #fff;\n  border-radius: 5px;\n  padding: 40px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.09);\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n.contact-form h2 { margin: 0; font-size: 26px; font-weight: 800; letter-spacing: -0.01em; }\n.contact-form label > span {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n.contact-form input[type='text'],\n.contact-form input[type='email'],\n.contact-form input[type='tel'],\n.contact-form textarea {\n  width: 100%;\n  box-sizing: border-box;\n  font: inherit;\n  font-size: 16px;\n  padding: 14px 16px;\n  border: 1.5px solid #e2e2e2;\n  border-radius: 5px;\n  background: #fafafa;\n  color: #2e2e2e;\n  transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;\n}\n.contact-form textarea { resize: vertical; min-height: 130px; }\n.contact-form input:focus,\n.contact-form textarea:focus {\n  outline: none;\n  border-color: #2e2e2e;\n  background: #fff;\n  box-shadow: 0 0 0 4px rgba(46, 46, 46, 0.08);\n}\n.contact-row { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }\n\n.contact-types {\n  border: 0;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n.contact-types legend { font-size: 14px; font-weight: 600; margin-bottom: 10px; padding: 0; }\n.contact-types label {\n  flex: 1 1 0;\n  min-width: 110px;\n  text-align: center;\n  padding: 12px 14px;\n  border: 1.5px solid #e2e2e2;\n  border-radius: 5px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.contact-types label:hover { border-color: #2e2e2e; }\n.contact-types label.selected { background: #2e2e2e; border-color: #2e2e2e; color: #fff; }\n.contact-types input { position: absolute; opacity: 0; pointer-events: none; }\n\n.contact-hp { position: absolute !important; left: -9999px; width: 1px; height: 1px; opacity: 0; }\n\n.contact-submit {\n  align-self: flex-start;\n  font: inherit;\n  font-size: 17px;\n  font-weight: 600;\n  color: #fff;\n  background: #2e2e2e;\n  border: 0;\n  border-radius: 5px;\n  padding: 16px 38px;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s, opacity 0.2s;\n}\n.contact-submit:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 10px 24px rgba(0, 0, 0, 0.2); }\n.contact-submit:disabled { opacity: 0.6; cursor: wait; }\n\n.contact-msg { margin: 0; padding: 14px 18px; border-radius: 5px; font-size: 15px; line-height: 1.5; }\n.contact-msg.ok { background: #e8f6ee; color: #1f6b42; }\n.contact-msg.err { background: #fdecec; color: #a12a2a; }\n\n@media (max-width: 900px) {\n  .contact-grid { grid-template-columns: 1fr; margin-top: -60px; }\n  .contact-hero { padding: 80px 0 110px; }\n}\n@media (max-width: 560px) {\n  .contact-container { padding: 0 16px; }\n  .contact-form { padding: 28px 20px; }\n  .contact-row { grid-template-columns: 1fr; }\n  .contact-submit { align-self: stretch; }\n  .contact-body { padding-bottom: 70px; }\n}\n@media (prefers-reduced-motion: reduce) {\n  .contact-hero-glow { animation: none; }\n}\n\n/* ---- Social cards: animations ---- */\n.contact-card {\n  position: relative;\n  overflow: hidden;\n  isolation: isolate;\n  animation: cardIn 0.7s cubic-bezier(0.2, 0.8, 0.2, 1) backwards;\n  animation-delay: calc(var(--i, 0) * 140ms + 150ms);\n  transition: transform 0.35s cubic-bezier(0.2, 0.8, 0.2, 1), box-shadow 0.35s ease, color 0.3s ease;\n}\n@keyframes cardIn {\n  from { opacity: 0; transform: translateX(-40px); }\n  to { opacity: 1; transform: none; }\n}\n\n/* Brand-colour fill that wipes in from the left on hover */\n.contact-card::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  background: var(--brand);\n  transform: translateX(-101%);\n  transition: transform 0.45s cubic-bezier(0.2, 0.8, 0.2, 1);\n}\n/* Diagonal light sweep */\n.contact-card::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -60%;\n  width: 40%;\n  height: 100%;\n  background: linear-gradient(100deg, transparent, rgba(255, 255, 255, 0.45), transparent);\n  transform: skewX(-20deg);\n  z-index: -1;\n  pointer-events: none;\n}\n.contact-card:hover::before { transform: none; }\n.contact-card:hover::after { animation: cardShine 0.9s ease; }\n@keyframes cardShine {\n  from { left: -60%; }\n  to { left: 130%; }\n}\n.contact-card:hover { transform: translateY(-4px) scale(1.015); }\n.contact-card:hover .contact-card-text strong,\n.contact-card:hover .contact-card-text small,\n.contact-card:hover .contact-card-value,\n.contact-card:hover .contact-card-arrow { color: #fff; }\n\n.contact-card--whatsapp { --brand: #25d366; }\n.contact-card--instagram { --brand: linear-gradient(45deg, #f09433, #dc2743 50%, #bc1888); }\n.contact-card--email { --brand: #2e2e2e; }\n\n/* Icon: idle pulse ring + hover wiggle */\n.contact-card-icon {\n  position: relative;\n  transition: background 0.3s ease, color 0.3s ease, transform 0.4s ease;\n}\n.contact-card-icon::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  border: 2px solid var(--ring, #2e2e2e);\n  opacity: 0;\n  animation: iconPulse 2.6s ease-out infinite;\n  animation-delay: calc(var(--i, 0) * 500ms);\n}\n.contact-card--whatsapp .contact-card-icon { --ring: #25d366; }\n.contact-card--instagram .contact-card-icon { --ring: #dc2743; }\n@keyframes iconPulse {\n  0% { transform: scale(1); opacity: 0.6; }\n  70%, 100% { transform: scale(1.7); opacity: 0; }\n}\n.contact-card:hover .contact-card-icon {\n  background: #fff;\n  color: #2e2e2e;\n  animation: iconWiggle 0.7s ease;\n}\n.contact-card--whatsapp:hover .contact-card-icon { color: #25d366; }\n.contact-card--instagram:hover .contact-card-icon { color: #dc2743; }\n@keyframes iconWiggle {\n  0% { transform: rotate(0) scale(1); }\n  25% { transform: rotate(-16deg) scale(1.18); }\n  50% { transform: rotate(12deg) scale(1.18); }\n  75% { transform: rotate(-6deg) scale(1.1); }\n  100% { transform: rotate(0) scale(1.1); }\n}\n\n.contact-card-arrow { transition: transform 0.3s ease, color 0.3s ease; }\n.contact-card:hover .contact-card-arrow { transform: translateX(8px); }\n\n.contact-card:active { transform: scale(0.98); }\n\n/* Form slides in too */\n.contact-form {\n  animation: formIn 0.8s cubic-bezier(0.2, 0.8, 0.2, 1) 0.2s backwards;\n}\n@keyframes formIn {\n  from { opacity: 0; transform: translateY(30px); }\n  to { opacity: 1; transform: none; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .contact-card, .contact-form { opacity: 1; animation: none; }\n  .contact-card-icon::after { animation: none; }\n  .contact-card:hover .contact-card-icon { animation: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
